export default "/_next/static/b441f3d279b9aa743bf64225f290d96c.png";